<template>
    <div id="nuevo-minuta-acuerdo">
    <v-form v-model="formularioValido" ref="registraNuevoMinutaAcuerdo">
        <v-card flat>
            <v-card-title class="secondary--text">
            Registrar nuevo Acuerdo
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrar">
                <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
            </v-card-title>
            <v-divider class="mx-2"></v-divider>
            <v-card-text>
                <custom-text-field
                v-model="acuerdo.numero"
                label="Número"
                :rules="[mixReglas.requerido]"
                >
              </custom-text-field>
              <custom-date-picker
                v-model="acuerdo.fechaLimite"
                label="Fecha Límite"
                :rules="[mixReglas.requerido]">
                </custom-date-picker>
              <custom-text-area
                cols="12"
                v-model="acuerdo.descripcion"
                label="Descripción"
                rows="3"
                :rules="[mixReglas.requerido]">
              </custom-text-area>
                <custom-text-field
                  cols="12"
                  class=""
                  v-model="acuerdo.nombreReponsable"
                  label="Responsables"
                  :rules="[mixReglas.requerido]"
                  >
                </custom-text-field>
            </v-card-text>
            <v-divider class="bkground" />
            <v-card-actions>
                <v-spacer></v-spacer>
                <custom-button
                    @click="cerrar"
                    tipo="formCancelar"
                    label="Cancelar"
                    class="mr-3">
                </custom-button>
                <custom-button
                    @click="guardar"
                    tipo="formAceptar"
                    label="Guardar"
                    :disabled="!formularioValido ||
                    enviandoFormulario "
                    :loading="enviandoFormulario"
                    >
                </custom-button>
            </v-card-actions>
        </v-card>
    </v-form>
    </div>
</template>
<script>
import eventBus from '@/helpers/eventBus';
import CONTRATO_MINUTAS_PARTICIPANTES from '@/graphql/querys/administracion/minutas/contratoMinutasParticipantes.gql';
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
// import CustomSelect from '@/components/inputs/Select.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import mixAcuerdos from './mixAcuerdos';

export default {
  name: 'NuevoMinutaAcuerdo',
  mixins: [mixAcuerdos],
  props: {
    idMinuta: {
      type: String,
      required: true,
    },
    asunto: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      // responsable: null,
      acuerdo: {
        idMinuta: this.idMinuta,
        numero: this.asunto ? this.asunto.numero : '',
        descripcion: this.asunto ? this.asunto.descripcion : '',
        fechaLimite: '',
        nombreReponsable: this.asunto ? this.asunto.responsables : '',
        puestoResponsable: '',
        fechaHoraCumplimiento: null,

      },
    };
  },
  components: {
    CustomButton,
    CustomDatePicker,
    CustomTextArea,
    CustomTextField,
    // CustomSelect,
  },
  apollo: {
    contratoMinutasParticipantes: {
      query: CONTRATO_MINUTAS_PARTICIPANTES,
      variables() {
        return {
          idMinuta: this.idMinuta,
        };
      },
    },
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registraNuevoMinutaAcuerdo.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    async guardar() {
      // this.acuerdo.nombreReponsable = this.responsable.nombre;
      // this.acuerdo.puestoResponsable = this.responsable.puesto;
      await this.mixAgregarAcuerdo();
      eventBus.$emit('acuerdos-vencidos-actualizar');
    },
  },
  computed: {
    getParticipantesMinuta() {
      if (!this.contratoMinutasParticipantes) return [];
      return this.contratoMinutasParticipantes;
    },
  },
  watch: {
    asunto: {
      handler() {
        this.acuerdo.numero = this.asunto ? this.asunto.numero : '';
        this.acuerdo.descripcion = this.asunto ? this.asunto.descripcion : '';
        this.acuerdo.nombreReponsable = this.asunto ? this.asunto.responsables : '';
      },
    },
  },
};
</script>
